export default __webpack_public_path__ + "static/media/deductible.bcb56de1.svg";